import type { Option } from '$lib/types';
type Map = { [key: string]: string };
export const FILTER_GROUP_TO_FUND_KEY_MAP: Map = {
	investmentRole: 'investment_role',
	access: 'access',
	responsibilities: 'esg_classification',
	regions: 'investment_regions',
	domiciles: 'domicile',
	currencies: 'currency',
	themes: 'investment_themes',
	assetClasses: 'classification_assetclass',
	sfdrDisclosure: 'sfdr_product_type_article',
	managementStyle: 'management_style'
};

export const FILTER_GROUP_TO_QUERY_KEY_MAP: Map = {
	investmentRole: 'f--ir',
	access: 'f--as',
	assetClasses: 'f--ac',
	responsibilities: 'f--rb',
	markets: 'f--ma',
	regions: 'f--rg',
	domiciles: 'f--dc',
	currencies: 'f--cu',
	themes: 'f--th',
	matrix: 'f--mx',
	sfdrDisclosure: 'f--sf',
	managementStyle: 'f--ms'
};

export const QUERY_KEY_TO_FILTER_GROUP_MAP: Map = Object.entries(
	FILTER_GROUP_TO_QUERY_KEY_MAP
).reduce((map, [key, value]) => {
	map[value] = key;
	return map;
}, {} as Map);

export const FILTER_OPTIONS: Option[] = [
	{ value: 'ytd', label: 'YTD', longLabel: 'Year to date' },
	{ value: '3m', label: '3M', longLabel: '3 Months' },
	{ value: '6m', label: '6M', longLabel: '6 Months' },
	{ value: '1y', label: '1Y', longLabel: '1 Year' },
	{ value: '3y', label: '3Y', longLabel: '3 Years' },
	{ value: '5y', label: '5Y', longLabel: '5 Years' },
	{ value: '10y', label: '10Y', longLabel: '10 Years' }
];
